// extracted by mini-css-extract-plugin
module.exports = {"comparison":"ComparisonBarChart_comparison__1-ixW"};